import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Link,
  Paper,
  Container,
} from "@mui/material";
import { images } from "../../assets";

const LandingPage = () => {
  return (
    <Box sx={{ backgroundColor: "#f5f5f7", minHeight: "100vh" }}>
      {/* Logo */}
      <Box display="flex" justifyContent="center" sx={{ pt: { xs: 4, md: 6 } }}>
        <img
          src={images.certageLogo}
          alt="Logo"
          style={{
            width: "min(70vw, 300px)",
            height: "auto",
            maxHeight: "140px",
          }}
        />
      </Box>

      {/* Main Content */}
      <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2, md: 4 } }}>
        <Typography
          textAlign="center"
          fontFamily="Inter, sans-serif"
          color="#3F4145;"
          fontWeight={800}
          fontSize={{ xs: 20, md: 32 }}
          lineHeight={{ xs: "27.5px", md: "44px" }}
          sx={{ mt: { xs: 2, md: 3 } }}
        >
          Estimate your age with our AI-powered facial analysis
        </Typography>

        <Typography
          textAlign="center"
          fontFamily="Inter, sans-serif"
          color="#777"
          fontWeight={600}
          fontSize={{ xs: 14, md: 24 }}
          lineHeight={{ xs: "19.25px", md: "33px" }}
          sx={{ mt: { xs: 1, md: 2 } }}
        >
          Certage uses advanced AI-powered facial analysis to estimate your age
          quickly and anonymously, ensuring full{" "}
          <span style={{ fontWeight: 700 }}>GDPR compliance.</span>
        </Typography>

        {/* Grid Section */}
        <Grid
          container
          spacing={{ xs: 2, sm: 4 }}
          alignItems="center"
          justifyContent="center"
          sx={{ mt: { xs: 2, md: 4 } }}
        >
          {/* Image Section */}
          <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 2 } }}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                mt: { xs: 2, md: 0 },
              }}
            >
              <Box
                component="img"
                src={images.certageLandingLogo}
                alt="Facial Scan"
                sx={{
                  maxWidth: { xs: "90vw", sm: "70vw", md: "100%" },
                  height: { xs: "220px", sm: "320px", md: "470px" },
                  objectFit: "contain",
                }}
              />
            </Box>
          </Grid>

          {/* Text + Button Section */}
          <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 } }}>
            <Typography
              variant="body1"
              fontFamily="Inter, sans-serif"
              color="#777"
              fontWeight={600}
              fontSize={{ xs: 12, md: 20 }}
              textAlign={"center"}
              lineHeight={{ xs: "19.25px", md: "27.5px" }}
              sx={{ width: "100%", mb: 2 }}
            >
              In the next step, your camera will be activated to perform a
              facial analysis. It will only take a few seconds, and{" "}
              <strong>
                your photo will be deleted at the end of the process.
              </strong>
            </Typography>
            <Paper
              elevation={0}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                borderRadius: "14px",
                border: "1px solid #D4ECFF",
                background: { xs: "#fff", md: "#FBFDFF" },
                p: { xs: 2, md: "37px 15px" },
                boxSizing: "border-box",
                mb: 2,
              }}
            >
              <Button
                fullWidth
                sx={{
                  backgroundColor: "#1818de",
                  px: { xs: 0, sm: 5 },
                  py: 1.5,
                  width: "70%",
                  mx: "auto",
                  // fontSize: { xs: "0.95rem", sm: "1rem" },
                  borderRadius: "12px",
                  mb: 2,
                  fontSize: { xs: 20, sm: 24 },
                  fontWeight: 600,
                  color: "#fff",
                  "&:hover": { backgroundColor: "#1515b0" },
                }}
              >
                Start Verification
              </Button>

              <Typography
                variant="caption"
                color="#777"
                fontFamily="Inter, sans-serif"
                fontSize={{ xs: "0.7rem", sm: "0.75rem" }}
                sx={{ width: "100%" }}
              >
                By proceeding, you accept our{" "}
                <Link href="#" color="primary.text">
                  Terms & Conditions
                </Link>{" "}
                and{" "}
                <Link href="#" color="primary.text">
                  Privacy Policy
                </Link>
                . We do not store any personal data or images. The verification
                is performed in real time and only confirms your age.
              </Typography>
            </Paper>

            <Typography
              variant="body2"
              sx={{
                mt: 2,
                textAlign: "center",
                color: "#A1A1A1",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Cancel Verification
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default LandingPage;
